(ns ncr.reports.team
  (:require
   [ncr.reports.grid-cell :as gc]
   [ncr.reports.details]
   [ncr.reports.explain]
   [ncr.charts :as charts]
   [ncr.reports.common :as rc]))

(defn- detail-row [report path props]
  (gc/data-row report path props
    {:extension ncr.reports.explain/c-explain-team}))

(defn- summary [report [revenue costs pnl]]
  [(detail-row report revenue {:heading "Revenue"})
   (detail-row report costs {:heading "Costs"})
   (detail-row report pnl {:heading "PnL" :colorize? true})])

(defn- team-row [report path paths team-name]
  (gc/data-row report (assoc path :sym-path [])
    {:colorize? true
     :heading [charts/c-header-with-experimental-charts-button {:header team-name :paths paths :report report}]}
    {:extension ncr.reports.explain/c-explain-team
     :sub-rows
     (summary report paths)
     :filter-zeroes? true}))

(defn render [{:keys [labels] :as report} {:keys [heading]}]
  (let [path {:report-path [:projects-teams :teams]}
        cube (rc/from-path report path)
        values (get-in cube [:axes 0 :values :total])
        paths-total (rc/income-expense-pnl-paths (assoc path :cube-path [:total]))]
    (concat
      [{:type :header
        :heading [charts/c-header-with-experimental-charts-button {:header heading :paths paths-total :report report}]}]
      (into []
        (for [[team-id team-name] (sort-by val (select-keys labels values))
              :let [path (assoc path :cube-path [team-id])
                    paths (rc/income-expense-pnl-paths path)]]
          (team-row report path paths team-name)))
      (summary report paths-total))))




